export default "__VITE_ASSET__B8zwNeVT__"